import { FileInterface } from "../../../../types/RecordInterfaces";
import AppSpinner from "../../../../elements/AppSpinner";

const ImageCardListUploading = ({ file }: { file: FileInterface }) => {
  return (
    <div
      className="rounded-sm p-1 w-100"
      style={{
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
        maxWidth: 415,
      }}
    >
      <div className="d-flex align-items-center cursor-pointer">
        <div className="py-3 pl-3">
          <AppSpinner size="lg" />
        </div>
        <div className="ml-4">
          <h4 className="m-0 text-dark text-truncate pt-1 pr-2">
            {file?.Name}
          </h4>
          <p style={{ fontSize: 11 }} className="mb-1 mt-0">
            Uploading your file...
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImageCardListUploading;
